import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  personalInfo: {
    initialValue: {
      firstName: "",
      lastName: "",
      email: "",
      company: "",
      dob: "",
      mobile: "",
      designation: {
        id: 0,
        designationName: "",
        order: 0,
      },
      countrycode: "",
    },
  },
  manageAddress: {
    apiStates: {
      fetchProfileAddresses: true,
      postProfileAddresses: null,
      fetchDesignation: true,
      fetchCountryState: true,
    },
    selectedAddress: {
      fetchSelectedAddress: null,
    },
  },
  GSTINDetails: {
    apiStates: {
      fetchAllGSTINDetail: true,
      fetchAllEntityList: true,
      postProfileGSTINDetail: null,
      removerGSTINDetail:null,
      showGstinCheckBox:null
    },
    selectedGSTINDetail: {
      fetchSelectedGSTINDetail: null,
    },
  },
  changePassword: {},
  manageInterests: {},
  subscriptions: {},
  orders: {},
  virtualLibrary: {},
  wishlist: {},
  wallet: {},
  referEarn: {},
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setPersonalInfo: (state, action) => {
      state.personalInfo.initialValue = action.payload;
    },
    setFetchProfileAddresses: (state, action) => {
      state.manageAddress.apiStates.fetchProfileAddresses = action.payload;
    },
    setFetchDesignation: (state, action) => {
      state.manageAddress.apiStates.fetchDesignation = action.payload;
    },
    setFetchCountryState: (state, action) => {
      state.manageAddress.apiStates.fetchCountryState = action.payload;
    },
    setPostProfileAddresses: (state, action) => {
      state.manageAddress.apiStates.postProfileAddresses = action.payload;
    },
    setSelectedAddress: (state, action) => {
      state.manageAddress.selectedAddress.fetchSelectedAddress = action.payload;
    },
    setFetchGSTINDetails: (state, action) => {
      state.GSTINDetails.apiStates.fetchAllGSTINDetail = action.payload;
    },
    setFetchEntityTypeList: (state, action) => {
      state.GSTINDetails.apiStates.fetchAllEntityList = action.payload;
    },
    setPostProfileGSTINDetail: (state, action) => {
      state.GSTINDetails.apiStates.postProfileGSTINDetail = action.payload;
    },
    setRemoverGSTINDetail: (state, action) => {
      state.GSTINDetails.apiStates.removerGSTINDetail = action.payload;
      state.GSTINDetails.selectedGSTINDetail.fetchSelectedGSTINDetail =
        null;
    },
    setSelectedGSTINDetail: (state, action) => {
      state.GSTINDetails.selectedGSTINDetail.fetchSelectedGSTINDetail =
        action.payload;
    },
    setshowGstinCheckBox: (state, action) => {
      state.GSTINDetails.apiStates.showGstinCheckBox =
        action.payload;
    },
  },
});

export const {
  setFetchProfileAddresses,
  setFetchCountryState,
  setFetchDesignation,
  setSelectedAddress,
  setPostProfileAddresses,
  setFetchGSTINDetails,
  setFetchEntityTypeList,
  setPostProfileGSTINDetail,
  setSelectedGSTINDetail,
  setPersonalInfo,
  setRemoverGSTINDetail,
  setshowGstinCheckBox
} = profileSlice.actions;
export default profileSlice.reducer;
